import { useContext } from "react";
import {
  FileOperationsContext,
  FileOperationsContextValue,
} from "../providers/FileOperationsContext";

/**
 * Hook to access file operations context.
 * Must be used within a FileOperationsProvider.
 */
export const useFileOperations = (): FileOperationsContextValue => {
  const context = useContext(FileOperationsContext);
  if (!context) {
    throw new Error(
      "useFileOperations must be used within a FileOperationsProvider"
    );
  }
  return context;
};
